// src/components/Privacy.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

export default function Privacy() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div style={pageStyle}>
      {/* Bandeau en haut */}
      <div style={headerStyle}>
        <span style={logoStyle} onClick={() => navigate("/")} role="button">
          Dansy
        </span>
        <h1 style={titleStyle}>Politique de Confidentialité</h1>
      </div>

      {/* Contenu principal */}
      <div style={contentContainerStyle} data-aos="fade-up">
        <section>
          <h2 style={sectionTitleStyle}>1. Introduction</h2>
          <p style={paragraphStyle}>
            La présente Politique de Confidentialité a pour objectif de vous informer sur la manière dont nous collectons, utilisons, stockons et protégeons vos données personnelles sur le site Dansy.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>2. Collecte des données</h2>
          <p style={paragraphStyle}>
            Nous collectons diverses informations lorsque vous interagissez avec notre site. Ces informations peuvent inclure votre nom, adresse e-mail, adresse IP, et d'autres données fournies lors de votre inscription ou lors de l'utilisation de certaines fonctionnalités.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>3. Utilisation des données</h2>
          <p style={paragraphStyle}>
            Les données collectées sont utilisées pour améliorer notre service, personnaliser votre expérience, vous fournir un support efficace et vous informer des mises à jour importantes. Nous utilisons également ces informations pour analyser l'utilisation du site et optimiser nos offres.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>4. Responsable du traitement</h2>
          <p style={paragraphStyle}>
            Le responsable du traitement de vos données est [Nom de la société/organisme]. Pour toute question concernant la gestion de vos données personnelles, vous pouvez nous contacter à l'adresse suivante : privacy@dansy.com.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>5. Partage et divulgation des données</h2>
          <p style={paragraphStyle}>
            Vos informations personnelles ne sont communiquées à aucun tiers sans votre consentement, sauf si la loi l'exige ou pour répondre à des obligations contractuelles (par exemple, avec des prestataires de services soumis à une obligation de confidentialité).
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>6. Sécurité des données</h2>
          <p style={paragraphStyle}>
            Nous mettons en place des mesures techniques et organisationnelles adaptées pour protéger vos données personnelles contre tout accès non autorisé, altération, divulgation ou destruction. Toutefois, aucune méthode de transmission ou de stockage n'est totalement sécurisée.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>7. Cookies</h2>
          <p style={paragraphStyle}>
            Notre site utilise des cookies pour mémoriser vos préférences, faciliter votre navigation et analyser l'utilisation du site. Vous pouvez configurer votre navigateur pour refuser les cookies, bien que cela puisse affecter certaines fonctionnalités du site.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>8. Droits de l'utilisateur</h2>
          <p style={paragraphStyle}>
            Conformément à la réglementation en vigueur, vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition concernant vos données personnelles. Pour exercer ces droits, veuillez nous contacter à l'adresse : privacy@dansy.com.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>9. Conservation des données</h2>
          <p style={paragraphStyle}>
            Vos données personnelles sont conservées pendant la durée nécessaire à la réalisation des finalités pour lesquelles elles ont été collectées. Une fois ces finalités atteintes, vos données sont soit supprimées, soit anonymisées.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>10. Transfert international des données</h2>
          <p style={paragraphStyle}>
            Dans certains cas, vos données peuvent être transférées et stockées dans des pays situés en dehors de l'Espace Économique Européen. Dansy veille à ce que ces transferts soient encadrés par des garanties appropriées.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>11. Modifications de la Politique de Confidentialité</h2>
          <p style={paragraphStyle}>
            Nous nous réservons le droit de modifier cette Politique de Confidentialité à tout moment. Toute modification sera publiée sur cette page et prendra effet immédiatement. Nous vous recommandons de consulter régulièrement cette page pour être informé des mises à jour.
          </p>
        </section>
        <section>
          <h2 style={sectionTitleStyle}>12. Contact</h2>
          <p style={paragraphStyle}>
            Pour toute question relative à cette Politique de Confidentialité ou pour exercer vos droits, veuillez nous contacter à l'adresse suivante : support@dansy.com.
          </p>
        </section>
      </div>
    </div>
  );
}

/* =================== STYLES =================== */

const pageStyle = {
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  overflowX: "hidden",
  position: "relative",
  minHeight: "100vh",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: "60px" // ajout d'un padding pour éviter que le contenu ne se cache derrière le header
};

const headerStyle = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "linear-gradient(135deg, #fff0f3, #ffd6dd)",
  color: "#000",
  padding: "15px",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  height: "50px", // hauteur du header (augmentée pour une meilleure lisibilité)
  zIndex: 100,
};

const logoStyle = {
  position: "absolute",
  left: "20px",
  fontSize: "1.7rem",
  fontFamily: "'Shirkhand', cursive",
  color: "#ff477e",
  fontWeight: "bold",
  cursor: "pointer",
};

const titleStyle = {
  fontSize: "1.5rem",
  fontWeight: 700,
};

const contentContainerStyle = {
  marginTop: "100px", // espace entre le header et le contenu
  backgroundColor: "#fff",
  borderRadius: "20px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  padding: "30px",
  textAlign: "left",
  maxWidth: "800px",
  width: "90%",
  marginBottom: "40px",
};

const sectionTitleStyle = {
  fontSize: "1.8rem",
  color: "#333",
  margin: "20px 0 10px",
};

const paragraphStyle = {
  fontSize: "1rem",
  lineHeight: "1.6",
  color: "#555",
  marginBottom: "15px",
};
